import { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useDebouncedValue } from "shared/hooks/use-debounced-value";
import { instance } from "api/apiBase";

export const useBillingDetailController = (statementId: string) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery] = useDebouncedValue(searchQuery, 500);

  const detailsQuery = useQuery({
    queryKey: ["STATEMENT_DETAILS", statementId],
    queryFn: () =>
      instance
        .get(`/portal/v1/statements/${statementId}`)
        .then(({ data }) => data)
  });

  const activitiesQuery = useQuery({
    queryKey: ["STATEMENT_ACTIVITIES", page, debouncedSearchQuery],
    queryFn: () =>
      instance
        .get(`/portal/v1/statements/${statementId}/activities`, {
          params: {
            per_page: 10,
            page,
            search: debouncedSearchQuery
          }
        })
        .then(({ data }) => data),
    placeholderData: keepPreviousData
  });

  return {
    statementDetails: detailsQuery.data,
    isLoadingDetails: detailsQuery.isLoading,
    statementActivities: activitiesQuery.data,
    isFetchingActivities: activitiesQuery.isFetching,
    isLoadingActivities: activitiesQuery.isLoading,
    searchQuery,
    setSearchQuery,
    setPage
  };
};
